module.exports = __webpack_public_path__ + "./docs/img/icon-howto.e792c2c32f217ff276127bd0f5793db5.svg";